import { SaveEnumDynamicAttribute } from "@/modules/dynamic-attributes/feature/save-enum-dynamic-attribute";
import { AttributeForm } from "@/modules/dynamic-attributes/feature/save-simple-dynamic-attribute";
import Tabs from "@/shared/data-display/tabs";
import { DynamicAttributeEntity } from "gql/graphql";
import { useTranslations } from "use-intl";

type AddAttributesProps = {
  groupId?: string;
  dynamicAttributeEntity: DynamicAttributeEntity;
  category?: string;
  afterSubmit?: () => void;
};

export function AddAttributes(props: AddAttributesProps) {
  const t = useTranslations("DynamicAttributes");

  return (
    <Tabs
      items={[
        {
          key: "simple",
          label: t("Simple"),
          children: <AttributeForm {...props} />,
        },
        {
          key: "enum",
          label: t("Enum"),
          children: <SaveEnumDynamicAttribute {...props} />,
        },
      ]}
    />
  );
}
